import React, { Suspense } from "react";
import { BrowserRouter, Navigate, Routes, Route } from "react-router-dom";
import { observer } from "mobx-react-lite";
import ProtectedRoute from "./components/Common/ProtectedRoute.js";
import LoadingScreen from "./components/Common/LoadingScreen.js";

const AuthPage = React.lazy(() => import("./pages/AuthPage/AuthPage.js"));
const DashboardLayout = React.lazy(() => import("./pages/HomePage/DashboardLayout.js"));
const HomePage = React.lazy(() => import("./pages/HomePage/HomePage.js"));
const SessionsPage = React.lazy(() => import("./pages/HomePage/SessionsPage.js"));
const CampaignsPage = React.lazy(() => import("./pages/HomePage/CampaignsPage.js"));
const ProfilePage = React.lazy(() => import("./pages/ProfilePage/ProfilePage.js"));
const GamePage = React.lazy(() => import("./pages/GamePage/GamePage.js"));

const App = observer(() => {
  return (
    <BrowserRouter>
      <Suspense fallback={<LoadingScreen />}>
        <Routes>
          <Route path="/auth" element={<AuthPage />} />
          <Route
            path="/app"
            element={
              <ProtectedRoute>
                <DashboardLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<HomePage />} />
            <Route path="sessions" element={<SessionsPage />} />
            <Route path="campaigns" element={<CampaignsPage />} />
          </Route>
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <ProfilePage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/game/:sessionId"
            element={
              <ProtectedRoute>
                <GamePage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/app" replace />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
});

export default App;
